import {
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField,
} from "@mui/material";
import axios from "axios";
import { useDebouncedCallback } from "use-debounce";
import { useState } from "react";
import { toast } from "react-toastify";
import config from "../../utils/config";

function EgmImportDialog(props) {
	const [eventKey, setEventKey] = useState("");
	const [loading, setLoading] = useState(false);

	const close = () => {
		setEventKey("");
		props.onClose();
	}

	const importData = useDebouncedCallback(() => {
		if (eventKey === "") {
			toast.warning("Event Key cannot be empty.");
			return;
		}

		setLoading(true);

		axios
			.post(`${config.API_ENDPOINT}/events/${props.organization}/${props.event}/egm-import`, { egmToken: eventKey }, { headers: { "x-access-token": localStorage.getItem("access-token") } })
			.then(() => {
				setLoading(false);
				toast.success("Success!");
				close();
			})
			.catch(err => {
				setLoading(false);
				switch (err.response?.status) {
					case 401:
						localStorage.removeItem("access-token");
						window.location.replace("/login");
						break;
					default:
						toast.error("An unexpected error has occurred. Please verify your event key.");
						break;
				}
			});
	}, 500, { leading: true });

	return (
		<Dialog
			open={props.open}
			onClose={close}
			fullWidth
			maxWidth="sm"
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title" sx={{ pb: 1 }}>Import from ERS</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description" sx={{ mb: 2 }}>
					Import participants from ERS
				</DialogContentText>
				<TextField
					variant="outlined"
					required
					fullWidth
					label="Event Key"
					name="egmEventKey"
					type="password"
					autoComplete="off"
					value={eventKey}
					onChange={(e) => setEventKey(e.target.value)}
					sx={{ mb: 1 }}
				/>
			</DialogContent>
			{loading ? (
				<Box sx={{ display: "flex", justifyContent: "center", pb: 3 }}>
					<CircularProgress size={28} />
				</Box>
			) : (
				<DialogActions>
					<Button onClick={close} color="primary" sx={{ textTransform: "none", fontWeight: 600 }}>
						Cancel
					</Button>
					<Button onClick={importData} color="primary" autoFocus sx={{ textTransform: "none", fontWeight: 600 }}>
						Import
					</Button>
				</DialogActions>
			)
			}
		</Dialog >
	);
}

export default EgmImportDialog;